import { render } from "./MilestoneList.vue?vue&type=template&id=8f5515fe&ts=true"
import script from "./MilestoneList.vue?vue&type=script&lang=ts"
export * from "./MilestoneList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__